import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export const router = new Router({
  routes: [
    // {
    //     path: '/general',
    //     name: 'general',
    //     authRequired: true,
    //     component: Vue.component('general', () =>
    //             import ('../pages/general.vue')),
    //     meta: {
    //         breadcrumb: [
    //             { name: 'Prioridades', href: '' },{ name: 'Órdenes de trabajo', href: 'general' }
    //         ],
    //         code: 0,
    //         authRequired: true,
    //     }
    // },
    // {
    //     path: '/historico',
    //     name: 'historico',
    //     authRequired: true,
    //     component: Vue.component('historico', () =>
    //             import ('../pages/historico.vue')),
    //     meta: {
    //         breadcrumb: [
    //             { name: 'Prioridades', href: '' },{ name: 'Histórico de órdenes', href: 'historico' }
    //         ],
    //         code: 0,
    //         authRequired: true,
    //     }
    // },
    // {
    //     path: '/estados',
    //     name: 'estados',
    //     authRequired: true,
    //     component: Vue.component('estados', () =>
    //             import ('../pages/estados.vue')),
    //     meta: {
    //         breadcrumb: [
    //             { name: 'Prioridades', href: '' },{ name: 'Estados', href: 'estados' }
    //         ],
    //         code: 2,
    //         authRequired: true,
    //     }
    // },
    // {
    //     path: '/familiasMaterial',
    //     name: "familiasMaterial",
    //     authRequired: true,
    //     component: Vue.component('familiasMaterial', () =>
    //             import ('../pages/familiasMaterial.vue')),
    //     meta: {
    //         breadcrumb: [
    //             { name: 'Prioridades', href: '' },{ name: 'Familias de Material', href: 'familiasMaterial' }
    //         ],
    //         code: 2,
    //         authRequired: true,
    //     }
    // },
    // {
    //     path: '/prioridades',
    //     name: "prioridades",
    //     authRequired: true,
    //     component: Vue.component('prioridades', () =>
    //             import ('../pages/prioridades.vue')),
    //     meta: {
    //         breadcrumb: [
    //             { name: 'Prioridades', href: '' },{ name: 'Gestión de prioridades', href: 'prioridades' }
    //         ],
    //         code: 2,
    //         authRequired: true,
    //     }
    // },
    // {
    //     path: '/tiposIncidencia',
    //     name: 'tiposIncidencia',
    //     authRequired: true,
    //     component: Vue.component('tiposIncidencia', () =>
    //             import ('../pages/tiposIncidencia.vue')),
    //     meta: {
    //         breadcrumb: [
    //             { name: 'Prioridades', href: '' },{ name: 'Tipos de Incidencia', href: 'tiposIncidencia' }
    //         ],
    //         code: 2,
    //         authRequired: true,
    //     }
    // },
    {
      path: "/users",
      name: "users",
      authRequired: true,
      component: Vue.component("users", () => import("../pages/users.vue")),
      meta: {
        breadcrumb: [
          { name: "Prioridades", href: "" },
          { name: "Gestión de Usuarios", href: "users" }
        ],
        code: 2,
        authRequired: true
      }
    },
    {
      path: "/material",
      name: "material",
      authRequired: true,
      component: Vue.component("material", () =>
        import("../pages/material.vue")
      ),
      meta: {
        breadcrumb: [
          { name: "Trazabilidad", href: "" },
          { name: "Gestión de Materiales", href: "material" }
        ],
        code: 2,
        authRequired: true
      }
    },
    {
      path: "/notas",
      name: "notas",
      authRequired: true,
      component: Vue.component("notas", () => import("../pages/notas.vue")),
      meta: {
        breadcrumb: [
          { name: "Trazabilidad", href: "" },
          { name: "Notas", href: "notas" }
        ],
        code: 2,
        authRequired: true
      }
    },
    {
      path: "/proveedores",
      name: "proveedores",
      authRequired: true,
      component: Vue.component("proveedores", () =>
        import("../pages/proveedores.vue")
      ),
      meta: {
        breadcrumb: [
          { name: "Trazabilidad", href: "" },
          { name: "Proveedores", href: "proveedores" }
        ],
        code: 2,
        authRequired: true
      }
    },
    {
      path: "/ubicaciones",
      name: "ubicaciones",
      authRequired: true,
      component: Vue.component("ubicaciones", () =>
        import("../pages/ubicaciones.vue")
      ),
      meta: {
        breadcrumb: [
          { name: "Trazabilidad", href: "" },
          { name: "Ubicaciones", href: "ubicaciones" }
        ],
        code: 2,
        authRequired: true
      }
    },
    {
      path: "/compras",
      name: "compras",
      authRequired: true,
      component: Vue.component("compras", () => import("../pages/compras.vue")),
      meta: {
        breadcrumb: [
          { name: "Trazabilidad", href: "" },
          { name: "Compras", href: "compras" }
        ],
        code: 2,
        authRequired: true
      }
    },
    {
      path: "/comprasEcommerce",
      name: "comprasE",
      authRequired: true,
      component: Vue.component("comprasE", () =>
        import("../pages/ComprasE.vue")
      ),
      meta: {
        breadcrumb: [
          { name: "Trazabilidad", href: "" },
          { name: "Compras - Ecommerce", href: "compras" }
        ],
        code: 2,
        authRequired: true
      }
    },
    {
      path: "/productosEcommerce",
      name: "productosE",
      authRequired: true,
      component: Vue.component("productosE", () =>
        import("../pages/ProductosE.vue")
      ),
      meta: {
        breadcrumb: [
          { name: "Trazabilidad", href: "" },
          { name: "Productos - Ecommerce", href: "compras" }
        ],
        code: 2,
        authRequired: true
      }
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Vue.component("dashboard", () =>
        import("../pages/Dashboard.vue")
      ),
      loading: Vue.component("Error", () => import("../pages/core/Error.vue")),
      meta: {
        breadcrumb: [{ href: "dashboard" }],
        code: 2,
        authRequired: true
      }
    },
    {
      path: "/iot",
      name: "iot",
      component: Vue.component("iot", () =>
        import("../pages/IoT.vue")
      ),
      loading: Vue.component("Error", () => import("../pages/core/Error.vue")),
      meta: {
        breadcrumb: [{ href: "IoT" }],
        code: 2,
        authRequired: true
      }
    },
    {
      path: "/home",
      name: "Home",
      component: Vue.component("Home", () => import("../pages/Home.vue")),
      meta: {
        breadcrumb: [{ name: "Home", href: "Home" }],
        code: 0,
        authRequired: true
      }
    },
    {
      path: "/almacen3D",
      name: "Almacen3D",
      component: Vue.component("Almacen3D", () =>
        import("../pages/Almacen3D.vue")
      ),
      meta: {
        breadcrumb: [{ name: "Almacén 3D", href: "Almacen3D" }],
        code: 0,
        authRequired: true
      }
    },
    {
      path: "/maquinas3D",
      name: "Maquinas3D",
      component: Vue.component("Maquinas3D", () =>
        import("../pages/Maquinas3D.vue")
      ),
      meta: {
        breadcrumb: [{ name: "Máquinas 3D", href: "Maquinas3D" }],
        code: 0,
        authRequired: true
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Vue.component("Login", () =>
        import("../pages/core/Login.vue")
      ),
      meta: {
        authRequired: false,
        code: 0
      }
    },
    
    {
      path: "/*",
      redirect: "/login"
    }
  ]
});

router.beforeEach((to, from, next) => {
  const authRequired = to.meta.authRequired;
  const loggedIn = localStorage.getItem("user");
  const userData = JSON.parse(loggedIn);
  let token =
    !!userData && userData != null && userData.accessToken
      ? userData.accessToken
      : null;
  if (authRequired && token == null) {
    next("/login");
  } else {
    if (
      userData != null &&
      userData.roles &&
      ((userData.roles[userData.roles.length - 1] == "ROLE_TALLER" &&
        to.meta.code == 2) ||
        (userData.roles[userData.roles.length - 1] == "ROLE_OFICINA" &&
          to.meta.code == 1))
    ) {
      next("/home");
    } else {
      next();
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js